'use strict';

exports.__esModule = true;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SNAKE_CASE_REGEXP = /[A-Z]/g;
var CAMEL_CASE_REGEXP = /([:\-_]+(.))/g;

/**
 * Normalises data sets depending on serialisation method
 * @example
 * let caseNormaliser = new CaseNormaliser(CaseNormaliser.snakeCase);
 * let normalised = caseNormaliser([{ my_key: 123 }]);
 */

var CaseNormaliser = function () {

  /**
   * @param {function} [serialiser=camelCase()] - camelCase() or snakeCase()
   * @type {function}
   */
  function CaseNormaliser(serialiser) {
    (0, _classCallCheck3.default)(this, CaseNormaliser);

    /**
     * @type {function} [serialiser] - camelCase() or snakeCase()
     */
    this.serialiser = serialiser || this.camelCase;
  }

  /**
   * Invokes normalisation
   * @param {Object|Array} input - root node (either object or array)
   * @return {Object|Array} with normalised data
   */


  (0, _createClass3.default)(CaseNormaliser, [{
    key: 'call',
    value: function call(input) {
      return this.normalise(input, this.serialiser);
    }

    /**
     * Normalises data recursively depending on serialiser type
     * @param {Object|Array} data - root node (either object or array)
     * @return {Object} with normalised data
     * @access private
     */

  }, {
    key: 'normalise',
    value: function normalise(data, serialiser) {
      var _this = this;

      if (Array.isArray(data)) {
        data.forEach(function (value) {
          _this.normalise(value, serialiser);
        });
      } else if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var newKey = serialiser(key);

            if (newKey !== key) {
              // lets not delete keys in the same format
              (0, _defineProperty2.default)(data, newKey, (0, _getOwnPropertyDescriptor2.default)(data, key)); // replace old with new key
              delete data[key];
            }

            this.normalise(data[newKey], serialiser);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return data;
    }

    /**
     * Converts string to snake_case
     * @param {string} name - unnormalised value
     * @param {string} [ separator = _ ] - snake case separator
     * @return {string} normalised value
     * @access private
     */

  }], [{
    key: 'snakeCase',
    value: function snakeCase(name, separator) {
      separator = separator || '_';

      return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
        return (pos ? separator : '') + letter.toLowerCase();
      });
    }

    /**
     * Converts string to camelCase
     * @param {string} name - unnormalised value
     * @return {string} normalised value
     * @access private
     */

  }, {
    key: 'camelCase',
    value: function camelCase(name) {
      return name.replace(CAMEL_CASE_REGEXP, function (match, separator, letter, offset) {
        return offset ? letter.toUpperCase() : letter;
      });
    }
  }]);
  return CaseNormaliser;
}();

exports.default = CaseNormaliser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/services/case-normaliser.js
// module id = 259
// module chunks = 0